import { axiosClient } from "./axiosClient";

const aboutUsApis = {
  getContentAboutUs: () => axiosClient.get("/api/about-us"),
};

export default aboutUsApis;
